import { IApiRequest } from "@miplatform/types";
import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_REASON_GROUPS = `${TASK_SERVICE}/reasongroups`;

export const reasonGroups = {
  create: async ({ data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: API_REASON_GROUPS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  getAll: async ({ filters, sort }: IApiRequest) => {
    const options = await apiOptions({
      url: API_REASON_GROUPS,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
    });
    return apiRequest(options);
  },

  delete: async ({ id, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_REASON_GROUPS}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },

  update: async ({ id, data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_REASON_GROUPS}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  createReason: async ({
    groupId,
    name,
    toastMessageConfig,
  }: IApiRequest & { groupId: string; name: string }) => {
    const options = await apiOptions({
      url: `${API_REASON_GROUPS}/${groupId}/reasons/${name}`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },

  deleteReason: async ({
    groupId,
    name,
    toastMessageConfig,
  }: IApiRequest & { groupId: string; name: string }) => {
    const options = await apiOptions({
      url: `${API_REASON_GROUPS}/${groupId}/reasons/${name}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },

  getReasonsByName: async ({
    name,
    filters,
    sort,
    toastMessageConfig,
  }: IApiRequest & { name: string }) => {
    const options = await apiOptions({
      url: `${TASK_SERVICE}/reasongroups/${name}/reasons`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
    });
    return apiRequest(options, toastMessageConfig);
  },

  getCancelReasons: async ({ toastMessageConfig }: IApiRequest = {}) => {
    return reasonGroups.getReasonsByName({
      name: "CancelReasons",
      toastMessageConfig,
    });
  },

  getHoldReasons: async ({ toastMessageConfig }: IApiRequest = {}) => {
    return reasonGroups.getReasonsByName({
      name: "OrderHolds",
      toastMessageConfig,
    });
  },

  getReleaseReasons: async ({ toastMessageConfig }: IApiRequest = {}) => {
    return reasonGroups.getReasonsByName({
      name: "ReleaseReasons",
      toastMessageConfig,
    });
  },
};
